"use client"

import type React from "react"
import { IconContext } from "@phosphor-icons/react"

// App-wide default icon weight. Every Phosphor icon reads this from context
// instead of needing weight="bold" passed at each of the ~500 call sites.
// A component can still override locally by passing its own weight prop.
export function IconWeightProvider({ children }: { children: React.ReactNode }) {
  return <IconContext.Provider value={{ weight: "bold" }}>{children}</IconContext.Provider>
}
